
export enum OptimizerParameterTypeCd {
	DRIVER = 'Driver',
	EQUIPMENT = 'Equipment',
	OPTIMIZER = 'Optimizer',
	SHIPMENT = 'Shipment'}

